<!-- live -->
<template>
<div class="background">
  <div class="container">
    <div class="row">
      <div class="my-auto col">   
        <h1><div class="cont"><span class="inline">The&nbsp;</span><div class="inline"><transition v-on:appear="animate_hat"><div v-bind:style="{ transform: 'rotateZ(-15deg)'}" class="hat block"></div></transition><span class="block">Shuffle&nbsp;</span></div><span class="inline">Raffle</span></div></h1>
        <h2>Are you ready?</h2>
      </div>
      <div class="col-auto shuff-card mobile-top-margin">
        <transition v-on:appear="animate_glow">
          <img alt="Shuffle moster deck card logo" class="card-glow my-auto shuff-card-image-glow" width="320" src="../assets/cardseyeless.svg"/>
        </transition>
        <img alt="Shuffle moster deck card logo" class="my-auto shuff-card-image"  src="../assets/cardseyeless.svg"/>
        <transition v-on:appear="animate_eye">
          <img alt="Monster spining eye" class="my-auto eye" src="../assets/eye.svg">
        </transition>
        <img/>
      </div> 
    </div>
  </div>
</div>
</template>

<script>
 import Velocity from 'velocity-animate';
 const animate_times = 120;
 function random(min, max) {
   return (Math.random() * (max - min)) + min;
 }

export default {
  name: 'Head',

  methods: {
     animate_glow: function(el) {
      if(window.innerWidth>767){
       for (let i = 0; i < animate_times; i++) {
         el.velocity({opacity: random(0.5, 1)}, {
           duration: random(250, 1000),
        });
       }
      }
     },
     animate_eye: function(el) {
       var pos = 'rotateZ(0deg)';
       for (let i = 0; i < animate_times; i++) {
         var new_pos = "rotateZ("+random(0, 360)+"deg)"
         el.velocity({transform: [new_pos, pos]}, {
           delay: random(0, 5000),
           duration: random(250, 3000),
         })
         pos = new_pos;
       }
       
     },
      animate_hat: function(el) {
        var pos = 'rotateZ(-15deg)';
        for (let i = 0; i < 2; i++) {
          var new_pos = "rotateZ("+random(-35, -5)+"deg)"
          el.velocity({transform: [new_pos, pos]}, {
            delay: random(500, 1000),
            duration: random(300, 700),
          })
          pos = new_pos;
        }
        new_pos = 'rotateZ(-15deg)';
          el.velocity({transform: [new_pos, pos]}, {
            delay: random(500, 1000),
            duration: random(300, 700),
          })  
     }
  }
}

</script>

<style scoped>
.eye{
  position: absolute;
  top: 111px;
  left: 192.5px;
  width: 25px;
  z-index: 40;
  transform: rotateZ(0deg);
  will-change: transform;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.join-button {
  position: relative;
  text-align: left;
  display: flex;
  background-color: #AF2020;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border-color: #AF2020;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 93.19%;
  padding: 14px;
}
.shuff-card{
  width: 320px;
  height: auto;
  margin: auto;
}
.shuff-card-image{
  width: 290px;
  top:0px;
  left:15px;
  z-index: 31;
  position: absolute;
}
.shuff-card-image-glow{
  padding:5px;
  width: 240px;
  z-index: 30;
  position: relative;
}
.card-glow{
  -webkit-filter: drop-shadow(0 0 100px rgba(0, 255, 71, 1)); 
  filter: drop-shadow(0 0 100px rgba(0, 255, 71, 1)); 
}
.background {
  min-height:381.86px;
  position: static;
  width: 100%;
  padding: 0;
  padding-top: 80px;
  padding-bottom: 80px;
  padding-left: 24px;
  padding-right: 24px;
  background: linear-gradient(308.23deg, #21540F 44.93%, #0b1b0a 98.22%),  #153312 ;
}
.inline{  display:inline-block;}
.cont{  line-height:85px;}
.cont> * {vertical-align: bottom;}
.hat{ 
  vertical-align :bottom;
  height: 105px;
  width: 105px;
  padding-bottom:54px;
  margin-bottom: -59px;
  margin-left:-37px;
  background-image: url('../assets/hat-logo-transparent.png');
  background-repeat: no-repeat;
  background-position: left top;
  background-size: contain;
  opacity: 0.8;
} 
.block{display:block;}
h1,h2{
  position: static;
  text-align: left;
  line-height: 93.19%;
  display: flex;
  letter-spacing: -0.02em;
  color: #FFFFFF;
}
h1{
  text-shadow: 6px 6px 6px #000000;
  font-weight: 700;
  font-size: 85px;
}
h2{
  max-width: 431px;
  font-weight: 500;
  font-size: 30px;
}
@media screen and (max-width: 767px) {
  .mobile-top-margin {margin-top:44px;}
  .optimize{display:none !important;}
}
</style>
